import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Season } from '@coin/shared/season-mgmt/util';
import { LoadingService } from '@coin/shared/core/data-access';
import { SeasonProcessState } from '@coin/shared/core/util-enums';
import { environment } from '@coin/shared/core/util-environments';
import { PaginatedResult, SimpleTableService } from '@coin/shared/core/util-models';
import { Observable, of } from 'rxjs';
import { listExrSeasons } from '../mocks/exr-season-store';

@Injectable({
  providedIn: 'root'
})
export class ExceptionalRecognitionSeasonService implements SimpleTableService {
  private httpClient = inject(HttpClient);
  private loadingService = inject(LoadingService);

  // TODO: Replace with real API call once the EXR seasons list endpoint exists. (GMTEC-23994)
  public queryPagedAndFilteredData = (page: number, size: number): Observable<PaginatedResult<Season>> =>
    of(listExrSeasons(page, size));

  // TODO: Replace with the real EXR backend once the season-state transition endpoint exists. (GMTEC-20689)
  public updateSeasonState(id: string, newState: SeasonProcessState): Observable<Season> {
    return this.loadingService.withLoadingScreen(
      this.httpClient.patch<Season>(
        `${environment.api.baseUrl}/admin/api/v1/exceptional-recognition/seasons/${id}/update-state`,
        { state: newState }
      )
    );
  }
}
